var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "level-left" }, [
    _c(
      "div",
      { staticClass: "level-item" },
      [
        _c(
          "b-select",
          {
            model: {
              value: _vm.perPageVal,
              callback: function($$v) {
                _vm.perPageVal = $$v
              },
              expression: "perPageVal"
            }
          },
          [
            _c("option", { attrs: { value: "5" } }, [_vm._v("5")]),
            _c("option", { attrs: { value: "10" } }, [_vm._v("10")]),
            _c("option", { attrs: { value: "20" } }, [_vm._v("20")]),
            _c("option", { attrs: { value: "50" } }, [_vm._v("50")]),
            !_vm.limitedPagination
              ? _c("option", { attrs: { value: "100" } }, [_vm._v("100")])
              : _vm._e()
          ]
        ),
        _c("span", { staticClass: "p-l-sm" }, [
          _vm._v(_vm._s(_vm.$t("pagination.per_page")))
        ])
      ],
      1
    ),
    _c(
      "div",
      { staticClass: "level-item" },
      [
        _c(
          "b-select",
          {
            model: {
              value: _vm.currentPageVal,
              callback: function($$v) {
                _vm.currentPageVal = $$v
              },
              expression: "currentPageVal"
            }
          },
          _vm._l(_vm.numofPage, function(index) {
            return _c("option", { key: index, domProps: { value: index } }, [
              _vm._v(" " + _vm._s(index) + " ")
            ])
          }),
          0
        ),
        _c("span", { staticClass: "p-l-sm" }, [
          _vm._v(_vm._s(_vm.$t("pagination.of_pages")))
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }